<div class="rfcc-report">
  <div class="report-header">
    <div>
      <h2>RFCC status report</h2>
      <p>MC coverage and RFCC signature status for the selected project.</p>
    </div>
    <div class="sort-controls">
      <label for="rfcc-sort">Sort by</label>
      <select id="rfcc-sort" [(ngModel)]="sortBy" (change)="sortGroups()">
        <option value="cpNumber">CP number</option>
        <option value="coverageStatus">Coverage</option>
        <option value="signatureCompletion">Signature completion</option>
      </select>
      <p-button [label]="sortDescending ? 'Descending' : 'Ascending'" severity="secondary" size="small" (onClick)="toggleSortDirection()"></p-button>
    </div>
  </div>

  @if (!loading && !error && reportData.length > 0) {
    <div class="status-bar" aria-label="RFCC CP status summary">
      <button type="button" class="status-item status-all" [class.active]="isFilterActive('ALL')" (click)="setFilter('ALL')"><strong>{{ cpGroups.length }}</strong> all CPs</button>
      <button type="button" class="status-item status-complete" [class.active]="isFilterActive('COMPLETE')" (click)="setFilter('COMPLETE')"><strong>{{ statusCounts.complete }}</strong> complete</button>
      <button type="button" class="status-item status-pending" [class.active]="isFilterActive('PENDING_SIGNATURES')" (click)="setFilter('PENDING_SIGNATURES')"><strong>{{ statusCounts.signaturesPending }}</strong> signatures pending</button>
      <button type="button" class="status-item status-partial" [class.active]="isFilterActive('PARTIAL')" (click)="setFilter('PARTIAL')"><strong>{{ statusCounts.partial }}</strong> incomplete coverage</button>
      <button type="button" class="status-item status-no-rfcc" [class.active]="isFilterActive('NO_RFCC')" (click)="setFilter('NO_RFCC')"><strong>{{ statusCounts.noRfcc }}</strong> without RFCC</button>
    </div>
  }

  @if (loading) {
    <div class="loading-state"><p-progress-spinner ariaLabel="Loading RFCC report"></p-progress-spinner></div>
  } @else if (error) {
    <p-message severity="error" text="Could not load the RFCC status report."></p-message>
  } @else if (reportData.length === 0) {
    <p-message severity="secondary" text="No RFCC certificates are available for the selected project."></p-message>
  } @else if (visibleCpGroups.length === 0) {
    <p-message severity="secondary" text="No RFCC certificates have pending signatures."></p-message>
  } @else {
    <div class="cp-card-list">
      @for (group of visibleCpGroups; track group.cpNumber) {
        <p-card [styleClass]="'cp-card ' + cpClass(group.rows)">
          <ng-template #header>
            <div class="cp-card-header"><span>CP {{ group.cpNumber }}</span><small>{{ group.rows.length }} RFCC certificate{{ group.rows.length === 1 ? '' : 's' }}</small></div>
          </ng-template>
          <div class="certificate-list">
            @for (row of group.rows; track row.rfccId) {
              <div class="certificate-card" [ngClass]="rowClass(row)">
                <div class="certificate-title">
                  @if (row.rfccId) {
                    <a class="certificate-link" [href]="'/cp/' + row.cpId + '/certificates/sign/rfcc/' + row.rfccId">{{ row.rfccDocumentNumber || 'Unnamed RFCC' }}</a>
                  } @else {
                    <strong>No RFCC certificate</strong>
                  }
                </div>
                <div><span class="field-label">MC coverage</span><strong>{{ row.coveredMcCsaCount }} / {{ row.totalMcCsaCount }}</strong><small>MC CSAs</small></div>
                <div><span class="field-label">Signatures</span><strong>{{ row.signedSignatureCount }} / {{ row.signatureCount }}</strong><small>{{ row.allSignaturesSigned ? 'All signed' : 'Pending' }}</small></div>
                <div class="people-cell"><span class="field-label">Signed by</span><span>{{ row.signedSigners || 'None' }}</span></div>
                <div class="people-cell"><span class="field-label">Pending signer / role</span><span>{{ row.pendingSigners || 'None' }}</span></div>
                <p-tag styleClass="coverage-pill" [severity]="coverageSeverity(row)" [value]="row.coverageStatus"></p-tag>
                @if (row.rfccId) {
                  <div class="reminder-action"><p-button label="Send reminder" icon="pi pi-send" severity="secondary" size="small" [loading]="remindingRfccId === row.rfccId" [disabled]="row.allSignaturesSigned || reminderSent.has(row.rfccId)" (onClick)="sendReminder(row)"></p-button>@if (reminderSent.has(row.rfccId)) { <small class="reminder-sent">Sent</small> }</div>
                } @else {
                  <span class="no-reminder">No reminder</span>
                }
              </div>
            }
          </div>
        </p-card>
      }
    </div>
  }
</div>
